import { useEffect, useState } from 'react';
import { getRouteUrl } from '../FormioComponents/utils';

export function clickSaveOnLeavingPageButton() {
  const leavingPageButton = document.querySelector("[name^='data[saveOnLeavingPageButton']");
  if (leavingPageButton) {
    leavingPageButton.click();
  }
}

function useLeavingPageHandler(claimType, currentPageLabel) {
  const [isLeavingSoSoonPopUpOpen, setIsLeavingSoSoonPopUpOpen] = useState(false);
  const changePath = (e) => {
    e.preventDefault();
    window.history.pushState(null, window.location.pathname, `#/${getRouteUrl(currentPageLabel, claimType) || ''}`);
    setIsLeavingSoSoonPopUpOpen(true);
  };

  useEffect(() => {
    function beforeunloadCallback() {
      // Uncomment the following line to enable the popup alert when leaving the page
      // e.returnValue = '';
      window.onbeforeunload = null;
      clickSaveOnLeavingPageButton();
    }

    function clickingOnLinksCallback(e) {
      const anchor = e.target.closest('a');
      if (anchor) {
        clickSaveOnLeavingPageButton();
      }
    }
    window.addEventListener('popstate', changePath);
    window.addEventListener('beforeunload', beforeunloadCallback);
    window.addEventListener('click', clickingOnLinksCallback);

    return () => {
      window.removeEventListener('beforeunload', beforeunloadCallback);
      window.removeEventListener('click', clickingOnLinksCallback);
      window.removeEventListener('popstate', changePath);
    };
  }, []);
  return { isLeavingSoSoonPopUpOpen, setIsLeavingSoSoonPopUpOpen, clickSaveOnLeavingPageButton };
}

export default useLeavingPageHandler;
